(function () {
'use strict';

angular
    .module('homeRoutes', [
        'homeControllers'
    ])
    .config(routeur);

    routeur.$inject = ['$stateProvider', '$urlRouterProvider'];

    function routeur($stateProvider, $urlRouterProvider) {
        $stateProvider
             .state('home', {
                 url: '/',
                 templateUrl: require('./home.tpl.html'),
                 controller: 'HomeController',
                 resolve: {
                     authenticatedUser: ['authenticatedUserService', function (service) {
                         return service.getAuthenticatedUser();
                     }]
                 }
             });

        $urlRouterProvider.otherwise('/');
    }
})();
